import { defineStore } from "pinia";
import api from "@/api/login";
import router from "../router";
import { ElMessage, ElMessageBox } from "element-plus";
import storage from "@/utils/storage";
import routerFormat from "@/utils/router";
import { routes, notFoundRouter } from "@/router";
import { msgType } from "@/enums/msgType";
import { t, clearDataByType } from "@/utils";
import messageApi from "@/api/config/conversation";
export const useStore = defineStore("useStore", {
  state: () => ({
    token: storage.get("token") || "",
    theme: storage.get("theme") || "light", // 主题
    info: {},
    addRouters: [],
    name: "",
    userMessage: [], // 消息列表
    sendMessageObject: {}, // 发送消息
    conversationItem: {}, // 当前选中的会话
    conversation: {}, // 接收的会话
    language: storage.get("language") || "en",
    connecting: false, // 连接状态
    conversationStatus: 1, // 会话状态 1：处理中2：已解决
    delMessage: {}, // 删除的消息
    scale: window.devicePixelRatio || 1, // 获取缩放比例
    ws: null,
    btnApi: [],
    receptionType: [
      msgType.text,
      msgType.image,
      msgType.video,
      msgType.file,
      msgType.review,
    ],
  }),
  getters: {
    myToken: (state) => state.token,
    myInfo: (state) => state.info,
    myName: (state) => state.name,
    routers: (state) => state.addRouters,
  },
  actions: {
    // 登陆
    async getLogin(val) {
      const {
        data: { data },
      } = await api.login(val);
      if (!data) return;
      // 存储token
      this.token = data.token;
      ElMessage.success(t("common.loginSuccess"));
      // 持久化存储token
      storage.set("token", data.token);
      router.replace("/");
    },

    // 退出
    async getOut() {
      try {
        await ElMessageBox.confirm(t("action.logout"), t("action.tips"), {
          type: "warning",
        });
        await api.logout();
        this.clearInfo();
        storage.clear();
        ElMessage.success(t("common.logoutSuccess"));
      } catch (err) {
        console.log(err);
      }
    },
    // 清空用户信息
    clearInfo() {
      const key = [
        "token",
        "name",
        "btnApi",
        "conversationItem",
        "conversation",
        "userMessage",
      ];
      clearDataByType(this, key);
      storage.remove("token");
      router.replace("/login");
      this.ws && this.ws.close();
    },
    // 获取用户信息
    async getInfo() {
      const { data } = await api.userInfo();
      if (data.code === 0) {
        this.name = data.data.name;
        this.setRouters(routerFormat(data.data.menuList));
        this.btnPermissions(data.data.menuList);
        this.info = data.data;
      }
      return data.code;
    },
    setRouters(routers) {
      this.addRouters = this.filterMenu(
        routers.concat(routes).concat(notFoundRouter)
      );
    },
    // 按钮接口
    btnPermissions(router) {
      router.forEach((item) => {
        if (item.children && item.children.length) {
          this.btnPermissions(item.children);
        } else {
          if (item.menuType === 2) {
            this.btnApi.push(item.interfacePath);
          }
        }
      });
    },
    // 递归过滤函数，过滤掉 menuType = 2 的菜单项
    filterMenu(menus) {
      return menus
        .filter((menuItem) => menuItem.menuType !== 2) // 过滤掉 menuType = 2 的项
        .map((menuItem) => {
          // 如果有 children，递归调用过滤函数
          if (menuItem.children && menuItem.children.length > 0) {
            return {
              ...menuItem,
              children: this.filterMenu(menuItem.children), // 递归过滤子菜单
            };
          }
          return menuItem;
        });
    },

    // 获取自动分配开关状态
    async getAutoAssignStatus() {
      const {
        data: { data },
      } = await messageApi.autoAssignStatus();
      return data?.isOpen;
    },
    // 获取vip列表
    async gradeList() {
      const { data } = await messageApi.getGradeList();
      if (data.code !== 0) return;
      return data.data.list;
    },
    // 获取客服列表
    async serviceList() {
      const { data } = await messageApi.getServiceList();
      if (data.code !== 0) return;
      return data.data.list;
    },
    // 获取标签列表
    async labelList() {
      // const { data } = await labelApi.listTag();
      // if (data.code !== 0) return;
      return [];
    },
    // 接收ws会话
    getSession(conversation) {
      this.conversation = conversation;
      if (conversation.msgType === msgType.messageTypeRemoteLogin) {
        ElMessageBox.confirm(
          t("action.accountLoginWarning"),
          t("action.tips"),
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            closeOnClickModal: false, // 禁止点击遮罩关闭
            closeOnPressEscape: false, // 禁止按 Esc 键关闭
          }
        ).then(() => {
          this.clearInfo();
        });
      }
      // 接收会话列表的消息
      if (
        conversation.conversationId === this.conversationItem.conversationId &&
        this.receptionType.includes(conversation.msgType)
      ) {
        this.userMessage.push({
          ...conversation,
          fromType: conversation.fromType,
        });
      }
    },
    // 获取当前会话
    async currentConversation(item, conversationItem, top) {
      this.conversationItem = conversationItem;
      const { data } = await messageApi.messageList(item);
      if (data.code !== 0 || !data.data.list) {
        return [];
      }
      if (!top) {
        this.userMessage = data.data.list;
      } else {
        this.userMessage = [...data.data.list, ...this.userMessage];
      }
      // this.userMessage = this.userMessage.filter(
      //   (i) => i.msgType !== msgType.assignAgent
      // );
      return data.data.list;
    },
    setServiceName(service) {
      Object.assign(this.conversationItem, {
        kfName: service.name,
        kfId: service.id,
        kfStatus: service.status,
      });
    },
    // 查询网路波动情况未收到消息查询
    async unreadList() {
      if (this.userMessage.length && this.conversationItem.conversationId) {
        const { data } = await messageApi.unreadMessageList({
          conversationId: this.conversationItem.conversationId,
          startId: this.userMessage[this.userMessage.length - 1].id,
        });
        if (data.code !== 0 || !data.data.list) return;
        this.userMessage.push(...data.data.list);
      }
    },
    // 翻译语言
    setLanguage(lang) {
      this.language = lang;
      storage.set("language", lang);
    },
  },
});
